import {
    CREATE_PROCESS_ADD_ON_REQUEST,
    CREATE_PROCESS_ADD_ON_SUCCESS,
    CREATE_PROCESS_ADD_ON_FAILURE,
    DELETE_PROCESS_ADD_ON_REQUEST,
    DELETE_PROCESS_ADD_ON_SUCCESS,
    DELETE_PROCESS_ADD_ON_FAILURE,
    FETCH_SINGLE_PROCESS_ADD_ON_REQUEST,
    FETCH_SINGLE_PROCESS_ADD_ON_SUCCESS,
    FETCH_SINGLE_PROCESS_ADD_ON_FAILURE,
    FETCH_PROCESS_ADD_ON_REQUEST,
    FETCH_PROCESS_ADD_ON_SUCCESS,
    FETCH_PROCESS_ADD_ON_FAILURE,
    UPDATE_PROCESS_ADD_ON_REQUEST,
    UPDATE_PROCESS_ADD_ON_SUCCESS,
    UPDATE_PROCESS_ADD_ON_FAILURE,
    RESET_PROCESS_ADD_ON_INFO,
    CREATE_PROCESS_ADD_ON_FORM,
    UPDATE_PROCESS_ADD_ON_FORM,
    FETCH_PROCESS_ADD_ON_SALESORDER_REQUEST,
    FETCH_PROCESS_ADD_ON_SALESORDER_SUCCESS,
    FETCH_PROCESS_ADD_ON_SALESORDER_FAILURE
} from './processAddOn.actionsType';

export const PROCESS_ADD_ON = 'processAddOn';

let initialState = {
    loading: false,
    processAddOnList: [],
    processAddOnSalesorderList: [],
    processAddOnform: {},
    selectedState: {},
    errorMessage: ''
};

export let processAddOnReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_PROCESS_ADD_ON_REQUEST:
        case CREATE_PROCESS_ADD_ON_REQUEST:
        case UPDATE_PROCESS_ADD_ON_REQUEST:
        case FETCH_SINGLE_PROCESS_ADD_ON_REQUEST:
        case DELETE_PROCESS_ADD_ON_REQUEST:
        case FETCH_PROCESS_ADD_ON_SALESORDER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROCESS_ADD_ON_SUCCESS:
            return {
                ...state,
                loading: false,
                processAddOnList: updatePayload
            };
        case FETCH_PROCESS_ADD_ON_SALESORDER_SUCCESS:
            return {
                ...state,
                loading: false,
                processAddOnSalesorderList: updatePayload
            };
        case CREATE_PROCESS_ADD_ON_SUCCESS:
            return {
                ...state,
                loading: false,
                processAddOnform: {}
            };
        case UPDATE_PROCESS_ADD_ON_SUCCESS:
            return {
                ...state,
                loading: false,
                processAddOnform: {}
            };
        case FETCH_SINGLE_PROCESS_ADD_ON_SUCCESS:
            return {
                ...state,
                loading: false,
                processAddOnform: updatePayload
            };
        case DELETE_PROCESS_ADD_ON_SUCCESS:
            return {
                ...state,
                loading: false,
                processAddOnform: {}
            };
        case RESET_PROCESS_ADD_ON_INFO:
            return {
                ...state,
                processAddOnform: {}
            };
        case CREATE_PROCESS_ADD_ON_FORM:
        case UPDATE_PROCESS_ADD_ON_FORM:
            return {
                ...state,
                loading: false,
                processAddOnform: {
                    ...state.processAddOnform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_PROCESS_ADD_ON_FAILURE:
        case CREATE_PROCESS_ADD_ON_FAILURE:
        case UPDATE_PROCESS_ADD_ON_FAILURE:
        case FETCH_SINGLE_PROCESS_ADD_ON_FAILURE:
        case DELETE_PROCESS_ADD_ON_FAILURE:
        case FETCH_PROCESS_ADD_ON_SALESORDER_FAILURE:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
};
